import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Card, message, Form, Button, InputNumber } from "antd";
import { getDrugs, upsertDrugs } from "services/api/drugs.api";
import { formatterNumber, parserNumber } from "utils/currency";
import { getToken } from "services/utils";
const Item = Form.Item;

const StyledInputNumber = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none !important;
  }
`;

const AdminDrugsPage = () => {
  const [form] = Form.useForm();
  const [drugs, setDrugs] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    (async () => {
      const { status, data } = await getDrugs({ idList: [], formType: "dRDh8Ews" });
      if (status === 200) {
        setDrugs(data.drugs);
      } else {
        message.error("Error fetching drugs");
      }
    })();
  }, []);

  const handleUpdateDrugs = async (changes) => {
    setIsSubmitting(true);
    const drugsArray = [];
    Object.keys(changes).forEach((key) => {
      drugsArray.push({
        name: key,
        charge: changes[key],
      });
    });

    const token = await getToken();
    const { status } = await upsertDrugs({ formList: drugsArray, token });
    if (status === 200) {
      message.success("Drugs updated successfully");
    } else {
      message.error("Error updating drugs");
    }
    setIsSubmitting(false);
  };

  return (
    <Card title="Drugs Lookup">
      {drugs.length === 0 && <div>Loading drugs from Typeform...</div>}
      {drugs.length > 0 && (
        <Form
          form={form}
          onFinish={handleUpdateDrugs}
          preserve={false}
          layout="horizontal"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
          initialValues={{
            ...drugs.reduce((acc, curr) => {
              acc[curr.name] = curr.charge;
              return acc;
            }, {}),
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "150px 100px",
              columnGap: "1rem",
              rowGap: "0.75rem",
              alignItems: "center",
              maxWidth: "400px",
            }}
          >
            {drugs.map((drug) => (
              <React.Fragment key={drug.name}>
                <div>{drug.name}</div>
                <Item name={drug.name} noStyle>
                  <StyledInputNumber placeholder="$0.00" parser={parserNumber} formatter={formatterNumber} />
                </Item>
              </React.Fragment>
            ))}
          </div>

          <Button type="primary" htmlType="submit" style={{ marginTop: "1rem" }} disabled={isSubmitting}>
            Update Prices
          </Button>
        </Form>
      )}
    </Card>
  );
};

export default AdminDrugsPage;
